// extracted by mini-css-extract-plugin
export default {"container":"mr6mW","wrapper":"O9jPs","starsActive":"sE1sc","starsInactive":"zM1zr","starButton":"_Wsq1","starIcon":"LISMW"};